import * as ActionTypes from "./ActionTypes";
import {ApiManager} from "../api/ApiManager";
import AccountData from "../models/IAccountData"

export class AccountDataActions {

    static fetchAccountDataSuccess(accountData: AccountData) {
        return {type: ActionTypes.FETCH_ACCOUNT_DATA_SUCCESS, accountData};
    }

    static fetchAccountData(dispatch: any) {
        return ApiManager.getOrionApis().getAccountData().then((accountData: AccountData) => {
            dispatch(AccountDataActions.fetchAccountDataSuccess(accountData));
        }).catch((error: any) => {
            console.error(error);
            throw (error);
        });
    };

}
